module.exports = __webpack_public_path__ + "static/media/Mobile.8cd7865d.svg";